import * as Yup from 'yup';
import { EXCEL_EXTENSIONS } from '@shared/constants/constants';
import { isValidFile } from '@shared/commonFunctions';

export const changeWorkflowStepSchema = Yup.object().shape({
  document: Yup.mixed().test('required', 'Please select a valid csv or excel file', (file: File) => isValidFile(file, EXCEL_EXTENSIONS)),
  workflowId: Yup.string().required('Select Workflow'),
  workflowStepId: Yup.string().required('Select workflow Step'),
});

export const reassignDealUserSchema = Yup.object().shape({
  document: Yup.mixed().test('required', 'Please select a valid csv or excel file', (file: File) => isValidFile(file, EXCEL_EXTENSIONS)),
  dealUser: Yup.string().required('Select Deal User'),
  assignTo: Yup.string().required('Select Assign To'),
});